export const API_ROOT = 'https://test-dougvet-api.herokuapp.com';
export const CLOUDINARY_UPLOAD_PRESET = "pb68to0z";
export const CLOUDINARY_CLOUD_NAME = "hvlstha2y";
export const CLOUDINARY_UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/upload`;



// WEBPACK FOOTER //
// ./src/config/app.test.js